<template>
  <PermissionDeniedCard
    logo-src="/campus_logo.svg"
    logo-alt="Campus"
    :title="pageTitle"
    :message="message"
    :button-text="buttonText"
    :loading="accessSyncPending"
    @action="handleAction"
  >
    <template v-if="showPaywallUi" #extra>
      <p class="text-sm text-gray-500 text-center">
        Wrong account?
        <button
          type="button"
          class="text-[#5769ff] hover:underline font-medium"
          @click="handleLogout"
        >
          Log out
        </button>
      </p>
    </template>
  </PermissionDeniedCard>
</template>

<script setup lang="ts">
import { PermissionDeniedCard } from '@outtalent-dev/shared'
import { usePermissionDeniedView } from '@/composables/usePermissionDeniedView'

const {
  accessSyncPending,
  pageTitle,
  message,
  buttonText,
  showPaywallUi,
  handleAction,
  handleLogout
} = usePermissionDeniedView()
</script>
